'use client';

import { Button, DialogFooter, ScrollArea } from '@shared/components/shadcn';
import { Error } from '@shared/icons/system';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { Link } from '../../../../Link/Link';

type ErrorStepProps = {
  onRetry: () => void;
};

function ErrorStep({ onRetry }: ErrorStepProps) {
  const t = useTranslations('global_dialogs.affordability_questionnaire.error');

  return (
    <div className="flex min-h-0 flex-1 flex-col pt-10 md:pt-6" data-testid="error-step" data-track-container="Affordability Error">
      <ScrollArea className="flex min-h-0 flex-1 flex-col gap-4">
        <Error size="extra-extra-large" data-testid="affordability-questionnaire-error-icon" />
        <div className="flex flex-col">
          <h4 className="mb-2 mt-3">{t('title')}</h4>
          <p className="paragraph text-foreground-subtle leading-relaxed">{t('description')}</p>
          <p className="paragraph text-foreground-subtle mt-10 mb-8 md:mt-5">
            {t.rich('help_message', {
              link: chunks => (
                <Link href={ROUTES.HELP_CENTRE.BASE_URL} target="_blank" rel="noopener" data-testid="help-link" data-track-name="Help">
                  {chunks}
                </Link>
              ),
            })}
          </p>
        </div>
      </ScrollArea>
      <DialogFooter data-track-container="Actions">
        <Button type="button" variant="primary" className="w-full md:w-auto" onClick={onRetry} data-testid="retry-button" data-track-name="Retry">
          {t('retry_button')}
        </Button>
      </DialogFooter>
    </div>
  );
}

export { ErrorStep };
